import { B2B } from 'src/store-config/B2B-Config'
import { B2C } from 'src/store-config/B2C-Config'

export const redirectToAccountUrl = (isB2B: boolean) => {
  return isB2B ? B2B.accountUrl : B2C.accountUrl
}
